<div class="site-nav transparent tabs">
<ul ngbNav #nav="ngbNav" class="justify-content-start nav nav-tabs"  [destroyOnHide]="false" (navChange)="onTabChange($event)">
  <li [ngbNavItem]="'system'" [disabled]="disableST || disableAllTabs">
    <a ngbNavLink>
      {{ 'RO_OPTIMIZER.DASHBOARD.SYSTEM' | translate }}
    </a>
    <ng-template ngbNavContent>
      <nalco-system *ngIf="!disableST" [siteId]="siteId" (scenarioData)="getScenarioData($event)" (tab)="getTabStatus($event)"
        [componentReady]="componentReady" [saveSuccess]="isSaved">
      </nalco-system>
    </ng-template>
  </li>
  <li [ngbNavItem]="'operatingParameter'" [disabled]="disableTabs || disableAllTabs">
    <a ngbNavLink>
      <span [ngClass]="opErrorTab ? 'error-tab' : ''">
        {{ 'RO_OPTIMIZER.DASHBOARD.OPERATING_PARAMETER' | translate }}
      </span>
    </a>
    <ng-template ngbNavContent>
      <nalco-operating-parameter [opData]="opTabData" [dimensionalUsageKeys]="dimensionalUsageKeys"
        (errorTabStatus)="getErrorTabStatus($event)" (calcLoaderStatus)="getLoaderStatus($event)">
      </nalco-operating-parameter>
    </ng-template>
  </li>
  <li [ngbNavItem]="'waterChemistry'" [disabled]="disableTabs || disableAllTabs">
    <a ngbNavLink>
      <span [ngClass]="wcErrorTab ? 'error-tab' : ''">
        {{ 'RO_OPTIMIZER.DASHBOARD.WATER_CHEMISTRY' | translate }}
      </span>
    </a>
    <ng-template ngbNavContent>
      <nalco-water-chemistry [wcData]="wcTabData" [dimensionalUsageKeys]="dimensionalUsageKeys"
        [pHControls]="pHControls" (errorTabStatus)="getErrorTabStatus($event)"
        (chargeBalanceValidation)="Validation($event)" [chargeBalanceInfo]="chargeBalance"
        (cbLoaderStatus)="getLoaderStatus($event)">
      </nalco-water-chemistry>
    </ng-template>
  </li>
  <li [ngbNavItem]="'dosageAndRecommendation'" [disabled]="disableTabs || disableAllTabs">
    <a ngbNavLink>
      <span [ngClass]="drErrorTab ? 'error-tab' : ''">
        {{ 'RO_OPTIMIZER.DASHBOARD.DOSAGE_AND_RECOMMENDATION' | translate }}
      </span>
    </a>
    <ng-template ngbNavContent>
      <nalco-dosage-and-recommendation [scenarioData]="scenarioData" [drData]="drTabData"
        [dimensionalUsageKeys]="dimensionalUsageKeys" (errorTabStatus)="getErrorTabStatus($event)"
        (saveStatus)="getsaveStatus($event)" [oipScenario]="isScenarioAtOIP" (phTableValidation)="Validation($event)"
        (saveLoaderStatus)="getLoaderStatus($event)">
      </nalco-dosage-and-recommendation>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" *ngIf="nav"></div>
</div>
<div *ngIf="isError">
  <nalco-tile [parentInstance]="myParentInstance()" [headerTitle]="" [errorData]='errorInfo' [showMoreOptions]=false
    [showInfoIcon]=false class="no-header">
    <div tile-content></div>
  </nalco-tile>
</div>